// eslint-disable-next-line import/prefer-default-export
// user data storage
export const userData = [
  {
    name: 'Jan',
    'Active User': 5200,
  },
  {
    name: 'Feb',
    'Active User': 4850,
  },
  {
    name: 'Mar',
    'Active User': 6100,
  },
  {
    name: 'APR',
    'Active User': 7320,
  },
  {
    name: 'MAY',
    'Active User': 6890,
  },
  {
    name: 'JUN',
    'Active User': 8200,
  },
  {
    name: 'JUL',
    'Active User': 9150,
  },
  {
    name: 'AUG',
    'Active User': 8750,
  },
  {
    name: 'SEP',
    'Active User': 9420,
  },
  {
    name: 'OCT',
    'Active User': 10500,
  },
  {
    name: 'NOV',
    'Active User': 11200,
  },
  {
    name: 'DEC',
    'Active User': 12800,
  },
];

// product Data storage
export const productData = [
  {
    name: 'Jan',
    Sales: '45.2%',
  },
  {
    name: 'Feb',
    Sales: '52.8%',
  },
  {
    name: 'Mar',
    Sales: '48.5%',
  },
  {
    name: 'APR',
    Sales: '61.3%',
  },
  {
    name: 'MAY',
    Sales: '68.9%',
  },
  {
    name: 'JUN',
    Sales: '72.4%',
  },
  {
    name: 'JUL',
    Sales: '78.6%',
  },
  {
    name: 'AUG',
    Sales: '69.2%',
  },
  {
    name: 'SEP',
    Sales: '74.8%',
  },
  {
    name: 'OCT',
    Sales: '82.5%',
  },
  {
    name: 'NOV',
    Sales: '85.1%',
  },
  {
    name: 'DEC',
    Sales: '91.3%',
  },
];

// user table data
export const userRows = [
  {
    id: 1,
    username: 'Sarah Johnson',
    avatar: 'https://randomuser.me/api/portraits/women/44.jpg',
    email: 'sarah.johnson@example.com',
    status: 'active',
    transaction: '$245.89',
  },
  {
    id: 2,
    username: 'Michael Chen',
    avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
    email: 'michael.chen@example.com',
    status: 'active',
    transaction: '$189.50',
  },
  {
    id: 3,
    username: 'Emily Davis',
    avatar: 'https://randomuser.me/api/portraits/women/68.jpg',
    email: 'emily.davis@example.com',
    status: 'active',
    transaction: '$312.25',
  },
  {
    id: 4,
    username: 'James Wilson',
    avatar: 'https://randomuser.me/api/portraits/men/75.jpg',
    email: 'james.wilson@example.com',
    status: 'active',
    transaction: '$428.60',
  },
  {
    id: 5,
    username: 'Sophia Martinez',
    avatar: 'https://randomuser.me/api/portraits/women/22.jpg',
    email: 'sophia.martinez@example.com',
    status: 'active',
    transaction: '$156.75',
  },
  {
    id: 6,
    username: 'David Thompson',
    avatar: 'https://randomuser.me/api/portraits/men/41.jpg',
    email: 'david.thompson@example.com',
    status: 'inactive',
    transaction: '$98.40',
  },
  {
    id: 7,
    username: 'Olivia Garcia',
    avatar: 'https://randomuser.me/api/portraits/women/85.jpg',
    email: 'olivia.garcia@example.com',
    status: 'active',
    transaction: '$534.20',
  },
  {
    id: 8,
    username: 'Daniel Anderson',
    avatar: 'https://randomuser.me/api/portraits/men/62.jpg',
    email: 'daniel.anderson@example.com',
    status: 'active',
    transaction: '$276.95',
  },
];

// product table data
export const productRows = [
  {
    id: 1,
    name: 'Wireless Bluetooth Headphones',
    avatar:
      'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=400',
    stock: 145,
    status: 'active',
    price: '$89.99',
  },
  {
    id: 2,
    name: 'Smart Watch Pro',
    avatar:
      'https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=400',
    stock: 87,
    status: 'active',
    price: '$299.99',
  },
  {
    id: 3,
    name: 'Laptop Backpack',
    avatar:
      'https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=400',
    stock: 234,
    status: 'active',
    price: '$45.50',
  },
  {
    id: 4,
    name: 'Mechanical Keyboard RGB',
    avatar:
      'https://images.unsplash.com/photo-1587829741301-dc798b83add3?w=400',
    stock: 92,
    status: 'active',
    price: '$129.99',
  },
  {
    id: 5,
    name: 'Wireless Mouse',
    avatar:
      'https://images.unsplash.com/photo-1527864550417-7fd91fc51a46?w=400',
    stock: 312,
    status: 'active',
    price: '$34.99',
  },
  {
    id: 6,
    name: 'USB-C Hub Adapter',
    avatar:
      'https://images.unsplash.com/photo-1625948515291-69613efd103f?w=400',
    stock: 45,
    status: 'inactive',
    price: '$49.99',
  },
  {
    id: 7,
    name: 'Portable SSD 1TB',
    avatar:
      'https://images.unsplash.com/photo-1597872200969-2b65d56bd16b?w=400',
    stock: 156,
    status: 'active',
    price: '$159.99',
  },
  {
    id: 8,
    name: 'Webcam HD 1080p',
    avatar:
      'https://images.unsplash.com/photo-1626033695556-5dd8c92b01b5?w=400',
    stock: 78,
    status: 'active',
    price: '$79.99',
  },
];
